import { render, staticRenderFns } from "./ProductCoverageTable.vue?vue&type=template&id=27217a84&"
import script from "./ProductCoverageTable.vue?vue&type=script&lang=js&"
export * from "./ProductCoverageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports